import type { FaireProductEntity } from "../../entity_types/product";

export const p_vnvw8rfbt4: FaireProductEntity = {
  token: "p_vnvw8rfbt4",
  type: "product",
  name: 'Homegrown JUMBO 8" CA White Sage Smudge Sticks',
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/d606a4214eeadf5f05594ed2b0536e7237ddc926eaf13379291131ce594267c1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dcaa26eb9dfe77c72ff55c535c7a050172b6ceb8eaa13a3a56c09c25b3b89783.jpeg",
    "https://cdn.faire.com/fastly/194d1e1a6097e934ef4a87192b63ac049e2f481f870e27b29ea6e01acbe88bbf.jpeg",
    "https://cdn.faire.com/fastly/d4e7d10018d6fb16fd1d7a875438d027061b51984b39d5ba5197a7ec88f712dc.jpeg",
    "https://cdn.faire.com/fastly/e46f158969774930f317474f8dca848d41d52f633ec0f2c776f1a23f2766843d.jpeg",
    "https://cdn.faire.com/fastly/bd93f54aa0a3de869a0e8f15cb6bc7925c8936676354214c53426fbb4642481d.jpeg",
    "https://cdn.faire.com/fastly/f1440c71a8b5b0db29c6ab08a8d77bfa874a0de3171c34a3443c03a08fdd0d68.jpeg",
  ],
  priceDollars: 9,
  description:
    'Our JUMBO 8" CA Sage Smudgesticks are the perfect fit for you, whether you\'re a sage pro or a beginner. Fresh and hand-tied, our bundles will leave your home surrounded with good vibes and a fresh sage-y aroma!\n\nSome of our bundles are actually homegrown and harvested which makes them SUPER fresh and fragnant. Our large sage plants produce a good amount of sage which we LOVE to use to provide our customers with the best sage we can find.\n\nSage is used to leave your home smelling fragrant and fresh and is also believed by many to have healing and spiritual benefits. It is said that burning sage in your home will being prosperity and wisdom to your home and anyone in your household.\n\nOur bundles of sage are each approximately 8" and are PERFECT for any sage beginner OR sage pro! Thank you for your support! :)',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:59.042Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
